<template>
  <div v-parallax-fit="parallax" ref="house" class="house-1">
    <img src="/themes/rise-theme/dist/images/estate/character-view/holly/09_House.png" alt="">
  </div>
</template>

<script>
export default {
  data() {
    return {
      mutationObserver: null,
      parallax: [
        {
          start: 3400,
          end: 4200,
          fromStyle: { transform: 'translateX(0%) translateY(-300%) rotateZ(-2deg)' },
          toStyle: { transform: 'translateX(0%) translateY(0%) rotateZ(0deg)' },
          easing: 'linear'
        }
      ]
    }
  },
  mounted() {
    const self = this;
    this.mutationObserver = new window.MutationObserver(mutationList => {
      mutationList.forEach(mutation => {
        if (mutation.target.style.transform == 'translateX(0%) translateY(0%) rotateZ(0deg)') {
          self.$evidence.value = null;
          self.$readMore.value = '';
        }
      });
    });

    this.mutationObserver.observe(this.$refs.house, {
      attributes: true,
      attributeFilter: ['style']
    });
  },
  unmounted() {
    this.mutationObserver.disconnect();
  }
}
</script>
